const modal = () => {
    // Modal

    const modalWindow = document.querySelector('.modal'),
        modalTrigger = document.querySelectorAll('[data-modal]');


    function openModal(){
        modalWindow.classList.remove('hide');
        modalWindow.classList.add('show');
        document.body.style.overflow = 'hidden';
        modalWindow.classList.add('fade');
        clearInterval(modalTimerId);
    }

    function closeModal(){
        modalWindow.classList.remove('show');
        document.body.style.overflow = '';
        modalWindow.classList.add('hide');
    }

    // Assign each button to call a modal window
    modalTrigger.forEach(item => {
        item.addEventListener('click', openModal);
    });

    // Close modal when user clicks Escape
    document.addEventListener('keydown', (e) =>{
        if (e.code === 'Escape' && modalWindow.classList.contains('show')){
            closeModal();
        }
    });

    // Close modal when the user clicks anywhere
    modalWindow.addEventListener('click', (e) => {
        if (e.target === modalWindow || e.target.getAttribute('data-modal') === ''){
            closeModal();
        }
    });

    // Close modal when the user clicks in X
    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal__close')){
            closeModal();
        }
    })

    // Timer for modal
    const modalTimerId = setTimeout(openModal, 15000);

    // Open modal window when user to scroll to the bottom of page

    function showModalByScroll() {
        if (window.pageYOffset + document.documentElement.clientHeight >=
            document.documentElement.scrollHeight -1){
            openModal();
            window.removeEventListener('scroll', showModalByScroll);
            clearInterval(modalTimerId);
        }
    }

    window.addEventListener('scroll', showModalByScroll);
}
export default modal;